import { useApolloClient, useLazyQuery, gql } from '@apollo/client';
import { WorkPackage } from '@bechtel/types';
import { forEach } from 'lodash';
import { GET_WORKPACKAGE_ADDITIONAL_INFO_BY_IDS } from '@bechtel/client-gql';

export function useWorkPackageCache() {
  const client = useApolloClient();
  const [loadUpdatedWorkpackage] = useLazyQuery<
    {
      workPackagesByIds: WorkPackage[];
    },
    {
      ids: string[];
    }
  >(GET_WORKPACKAGE_ADDITIONAL_INFO_BY_IDS, { fetchPolicy: 'network-only' });

  const updateWorkPackagesCache = (workPackageIds: string[]) => {
    if (!workPackageIds || workPackageIds.length == 0) return;
    const cachedWorkPackageIds: string[] = [];

    forEach(workPackageIds, (workPackageId) => {
      const cachedWorkPackage = client.readFragment({
        id: `WorkPackage:${workPackageId}`,
        fragment: gql`
          fragment wp on WorkPackage {
            id
          }
        `,
      });
      if (cachedWorkPackage) cachedWorkPackageIds.push(workPackageId);
    });
    if (cachedWorkPackageIds.length == 0) return;

    loadUpdatedWorkpackage({
      variables: {
        ids: cachedWorkPackageIds,
      },
    });
  };
  return { updateWorkPackagesCache };
}
